import s from "./ghl-ui.es1186.js";
import { createTheme as d } from "./ghl-ui.es855.js";
import C from "./ghl-ui.es1157.js";
import b from "./ghl-ui.es1164.js";
import h from "./ghl-ui.es903.js";
import f from "./ghl-ui.es1029.js";
const g = (r) => {
  const {
    popoverColor: t,
    textColor2: e,
    primaryColor: i,
    hoverColor: m,
    dividerColor: l,
    opacityDisabled: a,
    boxShadow2: c,
    borderRadius: o,
    iconColor: n,
    iconColorDisabled: p
  } = r;
  return Object.assign(Object.assign({}, s), {
    panelColor: t,
    panelBoxShadow: c,
    panelDividerColor: l,
    itemTextColor: e,
    itemTextColorActive: i,
    itemColorHover: m,
    itemOpacityDisabled: a,
    itemBorderRadius: o,
    borderRadius: o,
    iconColor: n,
    iconColorDisabled: p
  });
}, u = d({
  name: "TimePicker",
  common: C,
  peers: {
    Scrollbar: b,
    Button: h,
    Input: f
  },
  self: g
}), y = u;
export {
  y as default,
  g as self
};
